import { signal } from 'services/SignalsService'

const name = 'CASCADE-Drop'

async function execute() {
  const cascadeModel = game.models.CascadeModel.get()
  if(cascadeModel.positions[cascadeModel.currentCascade]){
    signal.dispatch('CASCADE-DROP-ANIM:START')
    return signal.promise('CASCADE-DROP-ANIM:DONE')
  }
  else{
    return Promise.resolve()
  }
}

export function getCascadeDropAction() {
  return {
    name,
    execute,
  }
}
